// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__SDGSX","form":"styles_form__2bxAJ"};